import { render, staticRenderFns } from "./simpleTable.vue?vue&type=template&id=e969abc6"
import script from "./simpleTable.vue?vue&type=script&lang=js"
export * from "./simpleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports